import React, { FC, useState } from 'react'
import { Box, Image, Layer } from 'grommet'
import { withPrefix } from 'gatsby'
import { ImageSrcI } from '../../custom-hooks/useLayoutConfig'
import Lightbox from '../lightbox/Lightbox'
import Loader from '../loader/Loader'

interface ImageCardPropsI {
  currentIndex: number
  allImages: ImageSrcI[]
}

const ImageCard: FC<ImageCardPropsI> = ({ currentIndex, allImages }: ImageCardPropsI) => {
  const [show, setShow] = useState(false)
  const [loading, setLoading] = useState(false)
  const hideLoader = (): void => setLoading(false)
  const showLoader = (): void => setLoading(true)
  const showPreview = (): void => setShow(true)
  const hidePreview = (): void => setShow(false)

  return (
    <React.Fragment>
      <Box elevation="medium" margin={{ bottom: 'medium', right: 'medium' }} animation="zoomIn" onClick={showPreview}>
        {loading && <Loader />}
        <Image
          fit="cover"
          onLoadStart={showLoader}
          onLoad={hideLoader}
          src={withPrefix(allImages[currentIndex].thumb)}
          a11yTitle={allImages[currentIndex].thumb}
        ></Image>
      </Box>
      {show && (
        <Layer onEsc={hidePreview} onClickOutside={hidePreview}>
          <Lightbox allImages={allImages} currentIndex={currentIndex} onClose={hidePreview} />
        </Layer>
      )}
    </React.Fragment>
  )
}

export default ImageCard
